import { Link } from 'react-router-dom';
import clsx from 'clsx';
import image from './logo-insignia.png';

interface LogoProps {
  className?: string;
}

export const Logo = (props: LogoProps) => (
  <Link className={clsx('h-[28px]', props.className)} to='/'>
    <img className='h-full object-contain' src={image} alt='Logo' />
  </Link>
);
